<template>
  <default-template>
    <template #default>
      <slot />
    </template>
    <!-- empty span so empty footer slot doesn't create a new line between elements -->
    <template #footer>
      <span />
    </template>
  </default-template>
</template>
<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import ErrorCapture from '~/mixins/ErrorCaptured'
import DefaultTemplate from './default.vue'

@Component({
  components: {
    DefaultTemplate,
  },
  mixins: [ErrorCapture],
})
class DefaultNoFooter extends Vue {}

export default toNative(DefaultNoFooter)
</script>
